<template>
  <spinner-container :loading="loading">
    <back-btn />
    <v-container>
      <v-row>
        <v-col lg="12">
          <v-card class="card--shadow">
            <v-card-text>
              <patient-info :patient="patient" />
            </v-card-text>
          </v-card>
          <v-card class="card--shadow">
            <v-card-text>
              <div>
                <v-btn
                  v-if="isPreEnroll"
                  @click="viewPreEnroll"
                  dark
                  depressed
                  color="teal accent-4"
                  outlined
                  class="mr-5"
                >
                  Go to Pre enroll Page
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>

                <v-btn
                  outlined
                  @click="viewEnroll"
                  dark
                  depressed
                  color="teal accent-4"
                >
                  Go to enroll Page
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
                <v-btn
                  @click="$router.push(`/patient-family/${$route.params.id}`)"
                  outlined
                  dark
                  depressed
                  color="teal accent-4"
                  class="ml-5"
                >
                  View Family Members
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
                <v-btn
                  @click="$router.push(`/delagated-person/${$route.params.id}`)"
                  outlined
                  dark
                  depressed
                  color="teal accent-4"
                  class="ml-5"
                >
                  Add Delagated person
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
                <br>
                <v-btn
                class="my-2"
                  outlined
                  @click="viewCluUpdate"
                  dark
                  depressed
                  color="teal accent-4"
                >
                  Go to Conclusion Update
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
                <v-btn
                  @click="$router.push(`/complementary-patient/${$route.params.id}/${$route.params.township_id}`)"
                  outlined
                  dark
                  depressed
                  color="teal accent-4"
                  class="ml-5"
                >
                  Complementary DRTB Support
                  <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col lg="10">
          <patient-form :patient="patient" @emitData="updatePatient" />
          <feedback
            :authorId="admin.id"
            :feedbacks="feedbacks"
            @createComment="createComment"
            @deleteComment="deleteComment"
          />
        </v-col>
      </v-row>
    </v-container>
  </spinner-container>
</template>

<script>
import PatientForm from "@/components/patient/PatientForm";
import Feedback from "@/components/feedback/Feedback";
import { mapState } from "vuex";
import SpinnerContainer from "@/components/container/SpinnerContainer";
import BackBtn from "@/components/navigation/BackBtn.vue";
import PatientInfo from "./component/patientInfo.vue";
export default {
  components: {
    PatientForm,
    SpinnerContainer,
    BackBtn,
    PatientInfo,
    Feedback,
  },
  data: () => ({}),
  computed: {
    ...mapState("Patient", ["patient", "isPreEnroll"]),
    ...mapState("Loading", ["loading"]),
    ...mapState("Feedback", ["feedbacks"]),
    ...mapState("Admin", ["admin"]),
  },
  methods: {
    createComment(comment) {
      const newComment = {
        item_id: this.$route.params.id,
        item_type: "PATIENT",
        author_id: this.admin.id,
        author_type: "PA",
        body: comment,
      };
      this.$store.dispatch("Feedback/create", newComment);
    },
    deleteComment(id) {
      this.$store.dispatch("Feedback/delete", id);
    },
    updatePatient(payload) {
      console.log(payload);
      this.$store.dispatch("Patient/updatePatient", payload);
    },
    viewPreEnroll() {
      this.$router.push({
        name: "pre-enroll",
        params: { id: this.$route.params.id },
      });
    },
    viewEnroll() {
      this.$router.push({
        name: "enroll",
        params: { id: this.$route.params.id,
          township_id:this.$route.params.township_id
         },
      });
    },
    viewCluUpdate() {
      this.$router.push({
        name: "enroll-clu",
        params: { patientId: this.$route.params.id,
            township_id:this.$route.params.township_id
         },
      });
    },
  },
  created() {
    this.$store.dispatch("Patient/getPatient", this.$route.params.id);
    this.$store.dispatch("Feedback/getAll", {
      item_id: this.$route.params.id,
      item_type: "PATIENT",
    });
  },
};
</script>
